(ns frontend.view.modals.nylas-connect.sub
  (:require [frontend.view.modals.nylas-connect.model :as model]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db model/root-path)))

(rf/reg-sub
 ::keep-private?
 :<-
 [::state]
 (fn [state _]
   (get state model/keep-private?-key)))

(rf/reg-sub
 ::sync-contacts?
 :<-
 [::state]
 (fn [state _]
   (get state model/sync-contacts?-key)))

(rf/reg-sub
 ::email-hint
 :<-
 [::state]
 (fn [state _]
   (get state model/email-hint-path)))
